
<template>
  <div class="gameboard">
<!--    <h1>Snake and ladder</h1>-->
    <div class="main" style="height: 526px;width:526px; overflow: visible" >
      <div class="superimposed" id="board"></div>
      <div id="side">
      <button class="btn" id="Play" @click="play()">New game</button><br>
        <button v-if="!isGameWon" id="dice"  @click="random()">&#9856;</button>
        <p>Total Rolls: {{this.totalRolls}}</p>
      </div>
      <div id="win-alert" v-if="isGameWon">
        <div class="win-message">{{this.auth.user.first_name}} Won! &#129395;
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import {mapGetters, mapState} from "vuex";

export default {
name: "Snakes",
  computed: {
    ...mapState("user", ["auth"]),
    ...mapGetters("user", ["isLogged"]),
  },

  methods:{
    play()
    {
      this.totalRolls=0;
      this.isGameWon=false;
      this.number=1;
          this.a=0;
          this.n=1;
          this.m=0;
      let s=document.getElementById("counter");
      try {

      document.getElementById("box"+this.n).removeChild(s);
      document.getElementById("box1").appendChild(s);
      }catch (e){}


      document.getElementById("board").style.visibility = "visible";
      document.getElementById("dice").style.visibility = "visible";
      // document.getElementById("Play").style.visibility = "hidden";
      document.getElementById("dice").innerHTML=this.dices[1];
    },
    random(){
      document.getElementById("dice").disabled=false;
      let dices=["","&#9856","&#9857","&#9858","&#9859","&#9860","&#9861"];
      this.a= Math.ceil(Math.random()*6);
      document.getElementById("dice").innerHTML=dices[this.a];
      // if(this.n+this.a>100)
      // {
      //   this.a=0;
      // }
      this.d=0;
      this.move()
    },
    move(){
      document.getElementById("dice").disabled=true;
      this.totalRolls++;
      this.t=setInterval(this.move2,200)
    },
    move2(){
      this.n++;
      this.m++;
      if(this.m<(this.a)||this.m==(this.a))
      {
        if(this.d==(this.a-1))
        {
          if (this.n==4)
          {
            this.n= 39;
          }
          else if (this.n==36)
          {
            this.n=8;
          }
          else if (this.n==30)
          {
            this.n=12;
          }
          else if (this.n==26)
          {
            this.n=75;
          }
          else if (this.n==33)
          {
            this.n=52;
          }
          else if (this.n==70)
          {
            this.n=50;
          }
          // else if (this.n==99)
          // {
          //   this.n=42;
          // }
          else if (this.n==59)
          {
            this.n=63;
          }
          else if (this.n==86)
          {
            this.n=57;
          }
          else if (this.n==73)
          {
            this.n=93;
          }


          else
          {
            // n=n;
          }
        }

        let s=document.getElementById("counter");
        document.getElementById("box"+this.n).appendChild(s);
        this.d+=1;
      }

      else
      {
        this.m=0;
        this.n-=1;
        clearInterval(this.t);
        document.getElementById("dice").disabled=false;
      }
      if (this.n>=100)
      {
        // alert("You win");
        this.isGameWon=true;
        document.getElementById("Play").style.visibility = "visible";
        // document.getElementById("dice").style.visibility = "hidden";
        this.n=1;
      }
    }


  },
  data() {
    return {
      totalRolls:0,
      isGameWon:false,
      number:1,
      a:0,
      // j:0,
      n:1,
      m:0,
      d:0,
      dices:["&#9856","&#9856","&#9857","&#9858","&#9859","&#9860","&#9861"],
      id:100,
    }
  },
  mounted() {


    for (let a=0;a<5;a++)
    {
      for (let b=0;b<=9;b++)
      {
        document.getElementById("board").innerHTML+="" +
            "<div " +
            "style='height: 52px;width: 52px;margin: 0'" +
            " class='boardbox left'" +
            " id='box"+(this.id)+"' " +
            "></div>"
        this.id--;
      }
      for (let c=9;c>=0;c--)
      {
        let temp = this.id +9 -c*2;

        document.getElementById("board").innerHTML+="<div " +
            "style='height: 52px;width: 52px;margin: 0'" +
            " class='boardbox right'id='box"+temp+"'></div>"
        this.id--;
      }
    }
    document.getElementById("box"+this.number).innerHTML=
        "<img width='35'" +
        " id='counter'" +
        " class='img'" +
        " src='http://www.freepngimg.com/thumb/chess/9-chess-pawn-png-image-thumb.png'>" +
        "</img>"

  }
}
</script>

<style scoped>body{
  background-color:#DEB887;
  display: block;
}

#win-alert{

  margin: auto;
  position: absolute;
  /*height: 100vh;*/
  background-color: rgba(100,256,100,0.8);
  top: 0; left: 0; bottom: 0; right: 0;
  font-size: 5rem;
  display: flex;
  justify-content: center;
  align-items: center;
}

.gameboard{
  margin:0 auto;

  /*position:relative;*/
  /*display: block;*/
}


h1
{
  text-align:center;
  background-color:#808000;
  padding:6px;
  color:white;
}

.main
{
  margin: 0 auto;
  /*margin-top: -26px;*/
  height:526px;
  width:526px;
  background-image:url("http://1.bp.blogspot.com/_UVqusWXd9Wk/S7NYgnLVzjI/AAAAAAAAKQw/T8dpgdPb-po/s320/snake+and+ladder+game.bmp");
  /*background-position-y: bottom;*/
  background-size:520px 520px;
  background-repeat:no-repeat;
  /*float:left;*/
  border:3px solid #a52a2a;
  overflow: auto;
}

.superimposed
{
  margin-top: -23px;
  /*position: absolute;*/
  display: flex;
  flex-wrap: wrap;
  /*flex-grow: 1;*/
  /*display: block;*/
  height:526px;
  width:526px;
  /*margin: 0;*/
  /*padding: 0;*/
  /*position:absolute;*/
  /*left:500px;*/
}

#side
{
  /*z-index: 10;*/
  text-align: center;
  /*height:500px;*/
  /*width:500px;*/
  /*margin-left:500px;*/
  /*margin: 0 auto;*/
}

.btn
{
  margin: 0 auto;
  height:40px;
  width:100px;
  /*margin-left:50px;*/
  /*margin-top:20px;*/
  border-radius:5px;
}
.boardbox
{
  margin: 0;
  display: block;

  /*min-height:50px !important;*/
  /*width:50px !important;*/
  z-index:-1;

}
.left
{
  float:left;
}
.right
{
  float:right;
}
.img
{
  position: relative;
  height:45px;
  width:50px;
  margin:2px 0px 3px 0px;
}
#dice
{
  height:80px;
  width:80px;
  font-size:70px;
  color:black;
  margin:auto;
  border:none;
  background-color:white;
}
#dice:active{
  outline: none !important;
}
</style>